import React, { Component } from "react";
import { withRouter } from "react-router";
import { ContextMenu, MenuItem, connectMenu } from "react-contextmenu";
import PropTypes from "prop-types";

import { STATUS } from "config/constants";
import copy from "utils/clipboard";

import styles from "./StoryMenu.css";

class StoryMenu extends Component {
  constructor(props) {
    super(props);

    this.preview = this._preview.bind(this);
    this.copyLink = this._copyLink.bind(this);
    this.sendAlert = this._sendAlert.bind(this);
    this.unschedule = this._unschedule.bind(this);
    this.unpublish = this._unpublish.bind(this);
    this.unfeature = this._unfeature.bind(this);
    this.delete = this._delete.bind(this);
  }

  _preview() {
    window.open(`${this.props.trigger.url}/preview`, "_blank");
  }

  _copyLink(e) {
    e.preventDefault();
    copy(`${this.props.trigger.publishedLink}`);
  }

  _sendAlert() {
    this.props.history.push(`${this.props.trigger.url}/send-alert`);
  }

  _unschedule() {
    this.props.history.push(`${this.props.trigger.url}/unschedule`);
  }

  _unpublish() {
    this.props.history.push(`${this.props.trigger.url}/unpublish`);
  }

  _unfeature() {
    this.props.history.push(`${this.props.trigger.url}/unfeature`);
  }

  _delete() {
    this.props.history.push(`${this.props.trigger.url}/delete`);
  }

  menuOptions(status, isNewsletter = false, isFeatured = false) {
    const preview = (
      <MenuItem onClick={this.preview} className="preview">
        Preview
      </MenuItem>
    );
    const unschedule = (
      <MenuItem
        onClick={this.unschedule}
        attributes={{ className: styles.warning }}
        className="unschedule"
      >
        Unschedule
      </MenuItem>
    );
    const unpublish = (
      <MenuItem
        onClick={this.unpublish}
        attributes={{ className: styles.warning }}
        className="unpublish"
      >
        Unpublish
      </MenuItem>
    );
    const unfeature = (
      <MenuItem onClick={this.unfeature} className="unfeature">
        Unfeature
      </MenuItem>
    );
    const deleteDraft = (
      <MenuItem
        onClick={this.delete}
        attributes={{ className: styles.warning }}
        className="delete"
      >
        Delete draft
      </MenuItem>
    );
    const sendAlert = (
      <MenuItem onClick={this.sendAlert} className="sendAlert">
        Send alert
      </MenuItem>
    );
    const copyLink = (
      <MenuItem onClick={this.copyLink} className="copyLink">
        Copy link
      </MenuItem>
    );

    switch (status) {
      case STATUS.UNASSIGNED.slug:
        return [preview, deleteDraft];
      case STATUS.IN_PROGRESS.slug:
        return [preview, deleteDraft];
      case STATUS.READY_FOR_EDITS.slug:
        return [preview, deleteDraft];
      case STATUS.SCHEDULED.slug:
        return [copyLink, preview, unschedule];
      case STATUS.PUBLISHED.slug: {
        if (isNewsletter) {
          return [copyLink, unpublish];
        }

        if (isFeatured) {
          return [copyLink, sendAlert, unfeature, unpublish];
        }

        return [copyLink, sendAlert, unpublish];
      }
      default:
        return [];
    }
  }

  render() {
    let menuEntries = [];
    if (this.props.trigger) {
      menuEntries = this.menuOptions(
        this.props.trigger.status,
        this.props.trigger.url.indexOf("newsletter") > -1,
        this.props.trigger.isFeatured
      );
    }

    return (
      <ContextMenu id="StoryMenu">
        {menuEntries.map((x, i) => ({ ...x, key: i }))}
      </ContextMenu>
    );
  }
}

StoryMenu.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(connectMenu("StoryMenu")(StoryMenu));
